var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyAvatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.333984,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F9F6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4166 23.834V22.1673C23.4166 21.2833 23.0654 20.4354 22.4403 19.8103C21.8152 19.1852 20.9673 18.834 20.0833 18.834H13.4166C12.5325 18.834 11.6847 19.1852 11.0596 19.8103C10.4344 20.4354 10.0833 21.2833 10.0833 22.1673V23.834M20.0833 12.1673C20.0833 14.0083 18.5909 15.5007 16.7499 15.5007C14.909 15.5007 13.4166 14.0083 13.4166 12.1673C13.4166 10.3264 14.909 8.83398 16.7499 8.83398C18.5909 8.83398 20.0833 10.3264 20.0833 12.1673Z",
    stroke: "#651D9C",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyAvatar);
export default __webpack_public_path__ + "static/media/empty-avatar.991962fbb17cb04080c15d5cacb34942.svg";
export { ForwardRef as ReactComponent };